export default __webpack_public_path__ + "assets/models/3f366242232008a16b8632f225f88454.glb";